import axios from 'axios';
import config from '../config';
import { showError } from '../utils';

// Generic network call function to handle common API request patterns
function networkCall({ method, url, headers, params, data, ...extraOptions }) {
  return axios({
    method,
    url,
    headers,
    params,
    data,
    ...extraOptions,
  })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const error = new Error('Invalid response');
        error.data = responseBody;
        throw error;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export const eapDashboard = (authToken, type) => {
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/eap-dashboard/eap-home`,
    headers: {
      authorization: authToken,
    },
    ...(type && { params: { type } }),
  });
};
export const eapTracker = (authToken) => {
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/eap-dashboard/eap-tracker`,
    headers: {
      authorization: authToken,
    },
  });
};
